import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgSearch = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M10 3.25a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5M1.75 10a8.25 8.25 0 1 1 14.59 5.28l5.69 5.69a.75.75 0 1 1-1.06 1.06l-5.69-5.69A8.25 8.25 0 0 1 1.75 10"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgSearch;
